import { MoonriseTheme } from "../.internal/themes/MoonriseTheme";
export default MoonriseTheme;